export const ArrowSize = 10;
export const GridStep = 30;
export const OPTION_NODE_TYPE = 'MENU_ITEM';
export const PathElbowRadius = 6;

export const START_NODE_ID = 'start_node_id';
export const RECT_MARGIN = 50;
export const DEFAULT_POSITION = { x: 0, y: 0 };

export enum TreeLayoutNodeTypeEnum {
  HIDDEN,
  NODE,
  OPTION,
  START,
}

export enum LinkType {
  ELBOWS3,
  ELBOWS2,
  ELBOWS2Right,
  DYNAMIC_LINK,
}

export enum DirectionType {
  Vertical,
  Horizontal,
  Diagonal,
}

export const NodeSize = Object.freeze({
  Default: { width: 153, height: 61 },
  OptionalNode: { width: 50, height: 18 },
  StartNode: { width: 80, height: 48 },
});

export const NodeDragFillColor = '#d8cdf8';
export const NodeHoverFillColor = '#e7dffd';
export const LineColor = '#CECECE';
export const SelectedFillColor = '#F2F0F8';
export const SelectedLineColor = '#8A6AEB';

export const ShiftLeftRightForOptionNode = 60;

export enum NodeSide {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
}
